import React from "react";

interface DialogContentProps {
    className?: string;
    styles?: React.CSSProperties;
    children?: any;
}

class DialogContent extends React.Component<DialogContentProps> {
    render() {
        return (
            <main
                className={`dialog-body ${this.props.className || ""}`}
                style={this.props.styles}>
                {this.props.children}
            </main>
        );
    }
}

export default DialogContent;
